"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modalActions = void 0;
const init_1 = __importDefault(require("./init"));
const toggle_1 = __importDefault(require("./toggle"));
exports.modalActions = {
    init: init_1.default,
    toggle: toggle_1.default
};
